import React, { useEffect, useRef, useState } from "react";
import TitlePages from "../../layout/TitlePages";
import "./Historia.css";

/**
 * Datos históricos del Instituto Tlaxcalteca de Elecciones (ITE)
 * Cronología institucional de 1986 a 2015 con preservación íntegra de textos
 * e iconografía vectorial temática representativa de cada evento.
 */
const HISTORIA_DATA = [
  {
    id: "evento-1986",
    year: "1986",
    lead: "Se promulga la Ley de Organizaciones Políticas y Procesos Electorales del Estado de Tlaxcala",
    text: "Durante el periodo de gestión del Gobernador del Estado Licenciado Tulio Hernández Gómez, regulando con ello el funcionamiento de la antigua Comisión Estatal Electoral.",
    icon: (
      /* 1986: Ley y Balanza de la Justicia Electoral */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 3v17M6 20h12M4 7l8-3 8 3M4 7l-2 7h6L6 7zM18 7l-2 7h6l-2-7z" />
      </svg>
    ),
  },
  {
    id: "evento-1993",
    year: "1993",
    lead: "El 15 de enero",
    text: "El Licenciado José Antonio Álvarez Lima convoca a los actores políticos y ciudadanos, a participar en la reforma electoral; a propósito, los Partidos Políticos efectuaron foros de consulta e instalaron mesas de trabajo en Municipios como Apizaco, Huamantla, Zacatelco, Calpulalpan y San Pablo del Monte.",
    icon: (
      /* 1993: Diálogo ciudadano, foros y mesas de trabajo */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="9" cy="7" r="3" />
        <path d="M3 18v-1a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v1" />
        <circle cx="17" cy="9" r="2.5" />
        <path d="M15 14a3.5 3.5 0 0 1 6 2v2" />
      </svg>
    ),
  },
  {
    id: "evento-1994",
    year: "1994",
    lead: "Se conforma el Instituto Electoral de Tlaxcala el 16 de agosto",
    text: "Integrado por un Consejo General formado por un Presidente, tres Consejeros Diputados, dos Consejeros de los Presidentes Municipales y 8 Consejeros Ciudadanos, así como un representante de cada Partido Político.",
    icon: (
      /* 1994: Edificio sede institucional del Instituto Electoral */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M3 21h18M4 18h16M12 3l9 5H3l9-5zM6 10v8M10 10v8M14 10v8M18 10v8" />
      </svg>
    ),
  },
  {
    id: "evento-1994-2",
    year: "1994",
    lead: "Decreto número 59 de fecha 12 de julio, el Congreso del Estado de Tlaxcala reforma el artículo 10",
    paragraphs: [
      "Mediante este decreto de la Constitución Política del Estado, se crea el Instituto Electoral de Tlaxcala, órgano que tendría a su cargo la dirección, organización y vigilancia de las elecciones en el Estado. Derivado de esta reforma, los Diputados del Congreso de Estado aprobaron en su decreto número 60, publicado en el Periódico Oficial del Gobierno del Estado el 25 de julio del mismo año, el Código Electoral del Estado de Tlaxcala.",
      "El 16 de agosto se erige formalmente el Instituto Electoral de Tlaxcala. El Consejo General fue integrado por un Presidente, tres Consejeros Diputados, dos Consejeros de los Presidentes Municipales y ocho Consejeros Ciudadanos, así como un representante de cada partido político.",
    ],
    icon: (
      /* 1994: Código Electoral y Libro de Leyes abierto */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M2 4.5A2.5 2.5 0 0 1 4.5 2H10a2 2 0 0 1 2 2v16a1.5 1.5 0 0 0-1.5-1.5H4.5A2.5 2.5 0 0 0 2 21V4.5zM22 4.5A2.5 2.5 0 0 0 19.5 2H14a2 2 0 0 0-2 2v16a1.5 1.5 0 0 1 1.5-1.5H19.5A2.5 2.5 0 0 1 22 21V4.5zM6 7h4M6 11h4M14 7h4M14 11h4" />
      </svg>
    ),
  },
  {
    id: "evento-1995",
    year: "1995",
    lead: "El Consejo General incluye la figura del Secretario.",
    text: "El Consejo General incluye la figura del Secretario.",
    icon: (
      /* 1995: Secretaría Ejecutiva / Acta y portafolios oficial */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="3" y="7" width="18" height="13" rx="2" />
        <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 13h18M10 13v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2" />
      </svg>
    ),
  },
  {
    id: "evento-1997",
    year: "1997",
    lead: "El Consejo General del Instituto Electoral de Tlaxcala, cambio su integración",
    text: "Con las reformas electorales del presente año, ahora se conformaría de la siguiente forma: un Presidente, un Secretario Ejecutivo, seis Concejales Electorales propietarios y dos Concejales Supernumerarios y un representante de cada Partido Político.",
    icon: (
      /* 1997: Organigrama colegiado de integración */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="9" y="3" width="6" height="4" rx="1" />
        <rect x="2" y="15" width="5" height="4" rx="1" />
        <rect x="9.5" y="15" width="5" height="4" rx="1" />
        <rect x="17" y="15" width="5" height="4" rx="1" />
        <path d="M12 7v4M4.5 15v-2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v2M12 11v4" />
      </svg>
    ),
  },
  {
    id: "evento-2003",
    year: "2003",
    lead: "Se renueva el Consejo General del Instituto Electoral de Tlaxcala",
    text: "Quedando integrado por un Consejero Presidente, seis Consejeros Electorales, con sus respectivos suplentes, además de un Secretario General, así como un representante de cada partido político.",
    icon: (
      /* 2003: Ciclo y renovación colegiada */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M21.5 2v6h-6M2.5 22v-6h6M21.5 8A10 10 0 0 0 4.1 6.8M2.5 16a10 10 0 0 0 17.4 1.2" />
        <circle cx="12" cy="12" r="2.5" />
      </svg>
    ),
  },
  {
    id: "evento-2006",
    year: "2006",
    lead: "El 30 de noviembre, se renueva el Consejo General del Instituto Electoral de Tlaxcala",
    text: "Para el periodo comprendido del uno de diciembre de 2006 al 30 de noviembre de 2009, integrado por una Consejera Presidenta, seis Consejeros Electorales y un Secretario General, de un representante de cada partido político.",
    icon: (
      /* 2006: Calendario oficial de periodo de gestión */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="3" y="4" width="18" height="17" rx="2" />
        <path d="M16 2v4M8 2v4M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 17h.01M12 17h4" />
      </svg>
    ),
  },
  {
    id: "evento-2008",
    year: "2008",
    lead: "El 24 de noviembre, mediante Decreto número 25",
    text: "Publicado en el Periódico Oficial del Gobierno del Estado, la LIX legislatura del Honorable Congreso del Estado emitió diversas reformas y adiciones al Código de Instituciones y Procedimientos Electorales para el Estado de Tlaxcala.",
    icon: (
      /* 2008: Pergamino de decreto y reformas legislativas */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M19 21H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v15zm0 0a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-3M7 8h8M7 12h5" />
        <circle cx="14" cy="15" r="2.5" />
      </svg>
    ),
  },
  {
    id: "evento-2009",
    year: "2009",
    lead: "Designación del Consejo General del Instituto Electoral de Tlaxcala",
    paragraphs: [
      "En cumplimiento al párrafo quinto del artículo 95 de la Constitución Política del Estado Libre y Soberano de Tlaxcala, y el artículo 157 del Código de Instituciones y Procedimientos Electorales del Estado de Tlaxcala, la LIX Legislatura del Honorable Congreso del Estado de Tlaxcala designó a los ciudadanos que integran el Consejo General del Instituto Electoral de Tlaxcala para el periodo comprendido del uno de diciembre de 2009 al 30 de noviembre de 2012; esto mediante Decreto número 124 de fecha 29 de noviembre de 2009.",
      "Posteriormente, en cumplimiento a la sentencia del Tribunal Federal Electoral del Poder Judicial de la Federación, en los autos de los juicios de revisión constitucional electoral y juicios para la protección de los derechos político-electorales del ciudadano, radicados bajo el número SUP-JRC-92/2009, la LIX Legislatura del Honorable Congreso del Estado de Tlaxcala, por Decreto número 130 de 19 de diciembre de 2009, designó a tres Consejeros Electorales, entre éstos, al Consejero Presidente, quienes integrarían el Consejo General del Instituto Electoral de Tlaxcala para el periodo comprendido del 19 de diciembre de 2009 al 30 de noviembre de 2012. Quedando la integración definitiva del Consejo General por un Consejero Presidente y seis Consejeros Electorales, un Secretario General del Instituto y un representante de los partidos políticos registrados y acreditados ante este órgano electoral.",
    ],
    icon: (
      /* 2009: Mazo de justicia electoral (resolución del Tribunal Electoral) */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="m14 13-7.5 7.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L11 10" />
        <path d="m16 16 6-6" />
        <path d="m8 8 6-6" />
        <path d="m9 7 8 8" />
        <path d="m21 11-8-8" />
      </svg>
    ),
  },
  {
    id: "evento-2012",
    year: "2012",
    lead: "Mediante el Decreto No. 126 se designan a los Consejeros Electorales",
    text: "Al Consejero Presidente, a los propietarios y suplentes, así como al Secretario General para un periodo de tres años, comprendido del uno de diciembre 2012 al 30 de noviembre de 2015.",
    icon: (
      /* 2012: Urna electoral ciudadana con boleta */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="3" y="9" width="18" height="12" rx="2" />
        <path d="M8 9V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5M9 6h6M8 14h8" />
        <circle cx="12" cy="15" r="1.5" />
      </svg>
    ),
  },
  {
    id: "evento-2015",
    year: "2015",
    lead: "Acuerdo INE/CG813/2015 y creación del Instituto Tlaxcalteca de Elecciones",
    paragraphs: [
      "Acuerdo INE/CG813/2015, por el que se aprueba la designación de la Consejera Presidenta y las y los Consejeros Electorales del Órgano Superior de Dirección del Organismo Público Local Electoral de Tlaxcala, así como los periodos de duración en el cargo.",
      "De manera consecuente, el dos de septiembre de 2015 se reforma la Ley de Instituciones y Procedimientos para el Estado de Tlaxcala, mediante Decreto No. 131, mediante el que quedan estipuladas las nuevas atribuciones, así como los mecanismos de interacción y coordinación a que deberá circunscribirse esta autoridad electoral local.",
      "Es así que el 3 de Septiembre del 2015 y ante una renovación del Consejo, el Instituto Electoral de Tlaxcala se extingue y se crea el Instituto Tlaxcalteca de Elecciones como el organismo público local que sustituye al antes mencionado.",
    ],
    icon: (
      /* 2015: Escudo con estrella institucional del nuevo ITE */
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 2l8 4.5v6c0 5.25-3.5 10-8 11.5-4.5-1.5-8-6.25-8-11.5v-6L12 2z" />
        <path d="M12 7l1.5 3 3.5.5-2.5 2.5.5 3.5-3-1.5-3 1.5.5-3.5-2.5-2.5 3.5-.5L12 7z" />
      </svg>
    ),
  },
];

const Historia = () => {
  // Estado React para conservar qué elementos ya fueron revelados (a prueba de reconciliaciones)
  const [visibleIndices, setVisibleIndices] = useState(() => new Set());
  const [activeIdx, setActiveIdx] = useState(0);

  // Estado para acordeones abiertos (Set con IDs únicos de los paneles abiertos)
  const [openIds, setOpenIds] = useState(() => new Set());

  const timelineRef = useRef(null);
  const progressRef = useRef(null);
  const itemRefs = useRef([]);
  const lastActiveRef = useRef(0);

  useEffect(() => {
    document.title = "Historia";
    // Garantizar lang="es" para guionado automático en español
    if (typeof document !== "undefined" && document.documentElement) {
      document.documentElement.lang = "es";
    }
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    let observer = null;
    let fallbackTimer = null;
    let resizeObserver = null;

    try {
      // 1. Agregar clase 'js' al elemento raíz
      document.documentElement.classList.add("js");

      // 2. Comprobar si el usuario prefiere movimiento reducido
      const isReduced =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (isReduced) {
        // En movimiento reducido: todo visible de inmediato sin animaciones
        setVisibleIndices(new Set(HISTORIA_DATA.map((_, i) => i)));
        itemRefs.current.forEach((el) => {
          if (el) el.classList.add("is-visible");
        });
        if (progressRef.current) progressRef.current.style.height = "100%";
        return;
      }

      // 3. Crear IntersectionObserver si está soportado
      if ("IntersectionObserver" in window) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const target = entry.target;
                // Marcar clase directa en DOM
                target.classList.add("is-visible");

                // Registrar en estado React para que persista a través de cualquier re-render
                const idx = Number(target.dataset.index);
                if (!isNaN(idx)) {
                  setVisibleIndices((prev) => {
                    if (prev.has(idx)) return prev;
                    const next = new Set(prev);
                    next.add(idx);
                    return next;
                  });
                }

                // Desobservar: se revela exactamente UNA vez y NUNCA se oculta al salir
                observer.unobserve(target);
              }
            });
          },
          {
            threshold: 0.1,
            rootMargin: "0px 0px -10% 0px",
          }
        );

        // Registrar elementos existentes en el observer
        itemRefs.current.forEach((el) => {
          if (el) observer.observe(el);
        });

        // Activar 'js-ready' SOLO después de registrar los elementos
        document.documentElement.classList.add("js-ready");
      } else {
        // Fallback para navegadores sin IntersectionObserver: dejar todo visible
        setVisibleIndices(new Set(HISTORIA_DATA.map((_, i) => i)));
        itemRefs.current.forEach((el) => {
          if (el) el.classList.add("is-visible");
        });
      }

      // 4. Respaldo de seguridad: a los 2 segundos, cualquier evento en el viewport se hace visible
      fallbackTimer = setTimeout(() => {
        const vh = window.innerHeight || document.documentElement.clientHeight || 800;
        itemRefs.current.forEach((el, idx) => {
          if (!el) return;
          const rect = el.getBoundingClientRect();
          if (rect.top <= vh) {
            el.classList.add("is-visible");
            setVisibleIndices((prev) => {
              if (prev.has(idx)) return prev;
              const next = new Set(prev);
              next.add(idx);
              return next;
            });
            if (observer) observer.unobserve(el);
          }
        });
      }, 2000);
    } catch (err) {
      console.error("Error al inicializar IntersectionObserver de Historia:", err);
      // En caso de cualquier error, garantizar que todo esté visible
      document.documentElement.classList.remove("js-ready");
      setVisibleIndices(new Set(HISTORIA_DATA.map((_, i) => i)));
      itemRefs.current.forEach((el) => {
        if (el) el.classList.add("is-visible");
      });
    }

    // 5. Control de progreso y nodo activo (sin alterar opacidades)
    let ticking = false;

    const updateTimelineProgress = () => {
      if (!timelineRef.current) {
        ticking = false;
        return;
      }

      const rect = timelineRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 800;
      const targetPoint = viewportHeight * 0.5;

      // Actualizar línea de progreso directamente sin disparar re-renders innecesarios
      const totalHeight = rect.height;
      if (totalHeight > 0 && progressRef.current) {
        const currentScroll = targetPoint - rect.top;
        const percent = Math.min(Math.max((currentScroll / totalHeight) * 100, 0), 100);
        progressRef.current.style.height = `${percent}%`;
      }

      // Determinación del evento activo más cercano al centro focal
      let closestIdx = -1;
      let minDistance = Infinity;

      itemRefs.current.forEach((el, idx) => {
        if (!el) return;
        const itemRect = el.getBoundingClientRect();
        const itemFocus = itemRect.top + 32;
        const dist = Math.abs(itemFocus - targetPoint);

        if (dist < minDistance) {
          minDistance = dist;
          closestIdx = idx;
        }
      });

      if (closestIdx !== -1 && closestIdx !== lastActiveRef.current) {
        lastActiveRef.current = closestIdx;
        setActiveIdx(closestIdx);
      }

      ticking = false;
    };

    const onScrollOrResize = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateTimelineProgress);
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize, { passive: true });

    // 6. ResizeObserver: recalcula automáticamente la barra al abrir o cerrar acordeones
    if ("ResizeObserver" in window && timelineRef.current) {
      resizeObserver = new ResizeObserver(() => {
        onScrollOrResize();
      });
      resizeObserver.observe(timelineRef.current);
    }

    // Ejecución inicial segura
    updateTimelineProgress();

    // 7. Apertura opcional por URL hash (ej. #evento-1993)
    if (window.location.hash) {
      const hashId = window.location.hash.replace("#", "");
      if (hashId && HISTORIA_DATA.some((it) => it.id === hashId)) {
        setOpenIds((prev) => new Set(prev).add(hashId));
        setTimeout(() => {
          const targetEl = document.getElementById(hashId);
          if (targetEl) {
            targetEl.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 350);
      }
    }

    return () => {
      if (observer) observer.disconnect();
      if (fallbackTimer) clearTimeout(fallbackTimer);
      if (resizeObserver) resizeObserver.disconnect();
      document.documentElement.classList.remove("js-ready");
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, []);

  // Manejador delegado sobre .timeline para alternar acordeones
  const handleTimelineClick = (e) => {
    const toggleBtn = e.target.closest(".timeline__toggle");
    if (!toggleBtn) return;

    e.preventDefault();
    const targetId = toggleBtn.getAttribute("aria-controls");
    if (!targetId) return;

    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(targetId)) {
        next.delete(targetId);
      } else {
        next.add(targetId);
      }
      return next;
    });
  };

  return (
    <>
      <TitlePages title="Historia" subTitle="" />

      <section
        className="timeline-section"
        aria-label="Línea del tiempo histórica del Instituto Tlaxcalteca de Elecciones"
      >
        <div className="timeline-wrapper">
          <ol
            className="timeline"
            ref={timelineRef}
            onClick={handleTimelineClick}
          >
            {/* Barra y progreso vertical */}
            <div className="timeline__line-track" aria-hidden="true">
              <div className="timeline__line-progress" ref={progressRef} />
            </div>

            {HISTORIA_DATA.map((item, index) => {
              const isEven = index % 2 !== 0; // index 0 = impar (izq), index 1 = par (der)
              const isVisible = visibleIndices.has(index);
              const isOpen = openIds.has(item.id);

              return (
                <li
                  key={`${item.year}-${index}`}
                  data-index={index}
                  className={`timeline__item ${isEven ? "timeline__item--even" : "timeline__item--odd"
                    } ${isVisible ? "is-visible" : ""} ${activeIdx === index ? "is-active" : ""
                    } ${isOpen ? "is-open" : ""}`}
                  ref={(el) => (itemRefs.current[index] = el)}
                >
                  {/* Nodo decorativo sobre la línea */}
                  <div className="timeline__node" aria-hidden="true" />

                  {/* Conector horizontal */}
                  <div className="timeline__connector" aria-hidden="true" />

                  {/* Tarjeta del evento con Acordeón */}
                  <div className="timeline__card">
                    <span className="timeline__watermark" aria-hidden="true">
                      {item.year}
                    </span>

                    <h3 className="timeline__heading-black" id={`heading-${item.id}`}>
                      <button
                        className="timeline__toggle"
                        type="button"
                        id={`btn-${item.id}`}
                        aria-expanded={isOpen ? "true" : "false"}
                        aria-controls={item.id}
                      >
                        <span className="timeline__title-black">{item.lead}</span>
                        <span className="timeline__action">
                          <span className="timeline__action-text">
                            {isOpen ? "Cerrar" : "Leer más"}
                          </span>
                          <span
                            className="timeline__chevron"
                            aria-hidden="true"
                          >
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <polyline points="6 9 12 15 18 9" />
                            </svg>
                          </span>
                        </span>
                      </button>
                    </h3>

                    <div
                      className={`timeline__panel ${isOpen ? "is-open" : ""}`}
                      id={item.id}
                      role="region"
                      aria-labelledby={`btn-${item.id}`}
                    >
                      <div className="timeline__panel-inner">
                        <div className="timeline__panel-content">
                          {item.paragraphs ? (
                            item.paragraphs.map((p, pIdx) => (
                              <p key={pIdx} className="timeline__text">
                                {p}
                              </p>
                            ))
                          ) : item.text ? (
                            <p className="timeline__text">{item.text}</p>
                          ) : (
                            <p className="timeline__text">{item.lead}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Lado opuesto (en escritorio aloja año e ícono temático discreto) */}
                  <div className="timeline__opposite">
                    <time className="timeline__year" dateTime={item.year}>
                      {item.year}
                    </time>
                    <div
                      className="timeline__icon timeline__icon--desktop"
                      aria-hidden="true"
                    >
                      <div className="timeline__icon-circle">{item.icon}</div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </section>
    </>
  );
};

export default Historia;
